import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import LandingDesktop from 'static/images/LandingDesktop.jpg';
import LandingMobile from 'static/images/LandingMobile.jpg';
import InteriorDesktop from 'static/images/InteriorDesktop.jpg';
import InteriorMobile from 'static/images/InteriorMobile.jpg';
// helpers&utils
import { isMobile } from 'app/helpers/utils';

import THEME from 'app/styles/theme';

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  display: flex;
  background: url(${({ initial }) =>
    initial
      ? isMobile ? LandingMobile : LandingDesktop
      : isMobile ? InteriorMobile : InteriorDesktop});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  @media screen and (max-width: ${THEME.breakpoints[1]}) {
    background-position: top;
  }
  @media screen and (max-width: ${THEME.breakpoints[0]}) {
    background-position: left;
  }
`;

const BackgroundImages = ({ initial }) => <Container initial={initial} />;

BackgroundImages.propType = {
  initial: PropTypes.bool.isRequired,
};

BackgroundImages.defaultProps = {
  // whether this is the initial background or
  // the reports background
  initial: true,
};

export default BackgroundImages;
